var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
a:{var Ba=$CLJS.ea.navigator;if(Ba){var Ca=Ba.userAgent;if(Ca){$CLJS.Aa=Ca;break a}}$CLJS.Aa=""};